// กติกาของขวัญที่ใช้ร่วมกันทั้งฝั่งข้อมูล (fb/chat.js, mock.js) และหน้าจอ (เอฟเฟกต์/บับเบิล) — ไม่มี dependency ใด ๆ
//  ระดับตามมูลค่า (คอยน์) : small < 100 · medium 100-499 · big >= 500 ; ส่งชิ้นเดิมซ้ำภายใน 3 วินาที = คอมโบ x2 x3 ...

export const TIER_MEDIUM = 100;
export const TIER_BIG = 500;
export const COMBO_MS = 3000;

/** มูลค่า (คอยน์) -> "small" | "medium" | "big" */
export function giftTier(cost) {
  const c = Number(cost) || 0;
  return c >= TIER_BIG ? "big" : c >= TIER_MEDIUM ? "medium" : "small";
}
/** ชื่อ intent ในไฟล์คำตอบ (chatbot_*.json) */
export const giftIntent = (cost) => `gift_${giftTier(cost)}`;

/**
 * คอมโบ : prev = ข้อความของขวัญก่อนหน้าของผู้ใช้ {giftId, combo, createdAt} หรือ null
 * ชิ้นเดิมและห่างไม่เกิน COMBO_MS -> combo ก่อนหน้า + 1 ; นอกนั้น 1 (เวลาในอนาคต/ผิดรูป = เริ่มใหม่)
 */
export function nextCombo(prev, giftId, now = Date.now()) {
  if (!prev || !giftId || prev.giftId !== giftId) return 1;
  const t = new Date(prev.createdAt).getTime();
  const dt = now - t;
  if (!Number.isFinite(t) || dt < 0 || dt > COMBO_MS) return 1;
  return Math.max(1, Math.floor(Number(prev.combo) || 1)) + 1;
}

/** ค่าความสัมพันธ์ที่เพิ่มตามมูลค่า (ใช้เมื่อห้องเปิดโหมดความสัมพันธ์) */
export function giftRelDelta(cost) {
  const c = Math.max(0, Number(cost) || 0);
  return { romantic: Math.min(30, Math.max(1, Math.ceil(c / 40))), intimacy: Math.min(40, Math.max(1, Math.ceil(c / 30))) };
}

/** ระยะเวลาเอฟเฟกต์ (ms) ต่อระดับ : 1.5-3 วินาที */
export const FX_MS = { small: 1800, medium: 2400, big: 3000 };
